(function () {
  if (window.__piraniVariantSyncBound) return;
  window.__piraniVariantSyncBound = true;

  function onVariantId(fn) {
    if (typeof fn !== "function") return;

    document.addEventListener("variant:change", function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && variant.id) fn(variant.id);
    });

    document.addEventListener(
      "change",
      function (event) {
        var input = event.target;
        if (!input || !input.matches || !input.matches("[data-variant-input]")) {
          return;
        }
        var form = input.closest("form");
        var idInput = form && form.querySelector('[name="id"]');
        if (idInput && idInput.value) fn(idInput.value);
      },
      true,
    );
  }

  function getMap(output) {
    var key = output && output.getAttribute("data-key");
    if (!key) return null;

    var scope = output.parentNode;
    if (!scope || !scope.querySelector) return null;

    var el = scope.querySelector(
      '[data-variant-content-map][data-key="' + key + '"]',
    );

    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  function showContent(variantId) {
    var id = String(variantId || "");

    document
      .querySelectorAll("[data-variant-content][data-key]")
      .forEach(function (output) {
        var map = getMap(output);
        if (!map) return;

        var html = Object.prototype.hasOwnProperty.call(map, id)
          ? map[id]
          : map.default;
        if (html != null) output.innerHTML = html;
      });
  }

  function revealImages(panel) {
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = "eager";
    });
  }

  function showPayload(variantId) {
    var id = String(variantId || "");
    if (!id) return;

    document
      .querySelectorAll("[data-variant-payload-group]")
      .forEach(function (group) {
        var panels = group.querySelectorAll("[data-variant-payload]");
        var match = null;
        var fallback = null;

        panels.forEach(function (panel) {
          var panelId = panel.getAttribute("data-variant-id");
          if (panelId === id) match = panel;
          if (panelId === "default") fallback = panel;
        });

        var target = match || fallback;
        group.hidden = !target;

        panels.forEach(function (panel) {
          var on = panel === target;
          panel.hidden = !on;
          if (on) revealImages(panel);
        });
      });
  }

  onVariantId(showContent);
  onVariantId(showPayload);
})();
